import { BigNumber } from 'ethers';
import { formatUnits } from 'ethers/lib/utils';

const formatNonNegative = (value: BigNumber, decimals: number = 18) =>
    value.lte('0') ? '0' : formatUnits(value, decimals);

export default formatNonNegative;
